import { render, staticRenderFns } from "./PerfilPublico.vue?vue&type=template&id=63ae689a&scoped=true&lang=pug"
import script from "./PerfilPublico.vue?vue&type=script&lang=js"
export * from "./PerfilPublico.vue?vue&type=script&lang=js"
import style0 from "./PerfilPublico.vue?vue&type=style&index=0&id=63ae689a&prod&lang=scss&scoped=true"
import style1 from "./PerfilPublico.vue?vue&type=style&index=1&id=63ae689a&prod&lang=scss"
import style2 from "./PerfilPublico.vue?vue&type=style&index=2&id=63ae689a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae689a",
  null
  
)

export default component.exports